export function exists(obj) {
  return obj !== null && obj !== undefined
}
